import checkChromatic from 'chromatic/isChromatic'

export const isChromatic = checkChromatic()
